import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import { SITE_LEVEL_PAGE_ID } from '../consts';
const SITE_LEVEL_ONLY = 'SITE_LEVEL_ONLY';
const SINGLE_ITEM_TYPE_ALL_PAGES = 'SINGLE_ITEM_TYPE_ALL_PAGES';
export const resolveGroupPageIdsForBmScanJob = (job, groupsDataMap) => {
  if (job.strategy === SITE_LEVEL_ONLY) {
    return groupsDataMap.has(SITE_LEVEL_PAGE_ID) ? [SITE_LEVEL_PAGE_ID] : [];
  }
  if (job.strategy === SINGLE_ITEM_TYPE_ALL_PAGES && job.itemType) {
    if (job.itemType === ITEM_TYPES.STATIC_PAGE_V2) {
      return [...groupsDataMap.entries()].filter(_ref => {
        let [, group] = _ref;
        return group.itemType === ITEM_TYPES.STATIC_PAGE_V2 && !group.isTpaPage;
      }).map(_ref2 => {
        let [pageId] = _ref2;
        return pageId;
      });
    }
    const tpaGroup = [...groupsDataMap.entries()].find(_ref3 => {
      let [, group] = _ref3;
      return group.itemType === job.itemType && group.isTpaPage;
    });
    return tpaGroup ? [tpaGroup[0]] : [];
  }
  return [];
};
//# sourceMappingURL=resolve-group-page-ids-for-bm-scan-job.js.map